var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_110_8924"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_110_8924)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.99980390625,29.3336921875C8.636033906249999,29.3336921875,2.66650390625,23.3640921875,2.66650390625,16.0002921875C2.66650390625,8.636522187499999,8.636033906249999,2.6669921875,15.99980390625,2.6669921875C23.36360390625,2.6669921875,29.33320390625,8.636522187499999,29.33320390625,16.0002921875C29.33320390625,23.3640921875,23.36360390625,29.3336921875,15.99980390625,29.3336921875ZM15.99980390625,26.6669921875C21.89090390625,26.6669921875,26.66650390625,21.8913921875,26.66650390625,16.0002921875C26.66650390625,10.1092821875,21.89090390625,5.3336621875,15.99980390625,5.3336621875C10.10879390625,5.3336621875,5.33317390625,10.1092821875,5.33317390625,16.0002921875C5.33317390625,21.8913921875,10.10879390625,26.6669921875,15.99980390625,26.6669921875ZM15.99980390625,14.1146921875L19.77100390625,10.3434721875L21.65660390625,12.2290821875L17.885403906249998,16.0002921875L21.65660390625,19.7714921875L19.77100390625,21.6570921875L15.99980390625,17.885892187499998L12.22859390625,21.6570921875L10.34298390625,19.7714921875L14.11420390625,16.0002921875L10.34298390625,12.2290821875L12.22859390625,10.3434721875L15.99980390625,14.1146921875Z",
    fill: "#FFF6DC",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleLine);
export default __webpack_public_path__ + "static/media/close-circle-line.40aa1ac925f6a3722352fe6274242b8c.svg";
export { ForwardRef as ReactComponent };